import React from 'react';
import { Box, Typography, makeStyles, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import community from "../../../src/components/Main/Landing/images/community.png";
import { ContainedButton } from "../../components/Main/Landing/components/buttons/Buttons";

const useStyles = makeStyles((theme) => ({
  ctaSection: {
    maxWidth: '1314px',
    width: 'calc(100% - 42px)',
    margin: '80px auto',
    padding: '60px 20px',
    textAlign: 'center',
    backgroundColor: '#1F1F1F',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '40px auto',
      padding: '40px 20px',
      width: 'calc(100% - 40px)',
      maxWidth: '380px',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '687px',
      height: '687px',
      backgroundColor: '#FD3C84',
      filter: 'blur(200px)',
      top: '-460px',
      left: '-244px',
      borderRadius: '50%',
      zIndex: 0,
      pointerEvents: 'none',
      [theme.breakpoints.down('sm')]: {
        width: '300px',
        height: '300px',
        top: '-150px',
        left: '-100px',
        filter: 'blur(100px)',
      }
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '335px',
      height: '335px',
      background: 'linear-gradient(180deg, #FECD3D 0%, #FFD761 40%, #F1A21F 100%)',
      filter: 'blur(150px)',
      bottom: '-100px',
      right: '-100px',
      borderRadius: '50%',
      zIndex: 0,
      pointerEvents: 'none',
      [theme.breakpoints.down('sm')]: {
        width: '200px',
        height: '200px',
        bottom: '-50px',
        right: '-50px',
        filter: 'blur(80px)',
      }
    }
  },
  ctaOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 0,
    pointerEvents: 'none',
  },
  ctaContent: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  ctaTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    marginBottom: '12px',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      lineHeight: 1.2,
      marginBottom: '16px',
      maxWidth: '250px',
    }
  },
  ctaSubtitle: {
    fontSize: '18px',
    color: '#FFFFFF',
    maxWidth: '600px',
    lineHeight: '27px',
    marginBottom: '28px',
    fontWeight: 200,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: "24px",
      marginBottom: '24px',
      maxWidth: '280px',
    }
  },
  ctaButton: {
    borderRadius: '6px !important',
    [theme.breakpoints.down('sm')]: {
      width: '190px !important',
      maxWidth: '100% !important',
      height: '38px !important',
      padding: '0 16px !important',
      fontSize: '16px !important',
    }
  },
  communitySection: {
    maxWidth: '1314px',
    width: 'calc(100% - 42px)',
    height: '330px',
    margin: '100px auto 80px',
    borderRadius: '16px',
    background: 'linear-gradient(90deg, #CE949C 0%, #E6B1BD 17.31%, #FFD0E1 36.06%, #CE949C 100%)',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    overflow: 'visible',
    position: 'relative',
    boxSizing: 'border-box',
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: 'auto',
      overflow: 'hidden',
      width: 'calc(100% - 40px)',
      margin: '60px auto',
      marginBottom: "0px"
    }
  },
  communityText: {
    flex: 1,
    padding: '60px 40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      padding: '40px 20px',
      alignItems: 'center',
      textAlign: 'center',
    }
  },
  communityTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    marginBottom: '16px',
    lineHeight: '100%',
    color: '#111',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
    }
  },
  communitySubtitle: {
    fontSize: '18px',
    fontFamily: "'Roboto', sans-serif",
    color: 'rgba(0, 0, 0, 0.8)',
    maxWidth: '430px',
    lineHeight: 1.4,
    fontWeight: 400,
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto 32px auto',
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.9)',
      lineHeight: '21px'
    }
  },
  communityButtons: {
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      maxWidth: '300px',
    }
  },
  btnPrimaryPink: {
    backgroundColor: '#FD3C84',
    height: "48px",
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 24px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E04882',
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      fontWeight: 500,
      fontSize: '14px',
      height: "38px",
      padding: '8px 24px',
      marginLeft: "auto",
      marginRight: "auto"

    }
  },
  btnSecondaryPink: {
    backgroundColor: 'transparent',
    color: '#FD3C84',
    height: "48px",
    border: '1px solid #FD3C84',
    borderRadius: '8px',
    padding: '10px 24px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(254, 90, 151, 0.1)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      height: "38px",
      padding: '8px 24px',
      marginLeft: "auto",
      marginRight: "auto",
      fontSize: '14px',
    }
  },
  communityImageContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginTop: '2px',
    }
  },
  communityImage: {
    maxWidth: '100%',
    height: '400px',
    objectFit: 'contain',
    display: 'block',
    objectPosition: 'bottom right',
    [theme.breakpoints.down('sm')]: {
      height: '300px',
      objectPosition: 'bottom center',
    }
  },
}));

export const GenesisInterestedCTA = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.ctaSection}>
      <Box className={classes.ctaOverlay} />
      <Box className={classes.ctaContent}>
        <Typography className={classes.ctaTitle}>
          Interested in Becoming a Genesis Creator?
        </Typography>
        <Typography className={classes.ctaSubtitle}>
          Think you have what it takes to join the Genesis Collection? Apply as a Creator and begin your journey.
        </Typography>
        <ContainedButton
          text="Apply As Creator"
          styles={classes.ctaButton}
          onClick={() => history.push('/apply-as-creator')}
        />
      </Box>
    </Box>
  );
};

export const GenesisCommunityCTA = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.communitySection}>
      <Box className={classes.communityText}>
        <Typography className={classes.communityTitle}>
          Become Part of the<br />SugarCribs Community
        </Typography>
        <Typography className={classes.communitySubtitle}>
          Whether you're looking to discover exclusive creators or become one yourself, your journey starts here.
        </Typography>
        <Box className={classes.communityButtons}>
          <button className={classes.btnPrimaryPink} onClick={() => history.push('/member-onboarding-step')}>Request Member Access</button>
          <button className={classes.btnSecondaryPink} onClick={() => history.push('/apply-as-creator')}>Apply As Creator</button>
        </Box>
      </Box>
      <Box className={classes.communityImageContainer}>
        <img
          src={community}
          alt="Community"
          className={classes.communityImage}
        />
      </Box>
    </Box>
  );
};

export const GenesisCTAs = () => {
  return (
    <>
      <GenesisInterestedCTA />
      <GenesisCommunityCTA />
    </>
  );
};
